import { $DOCUMENT, ACTIVE_CLASS, CURRENT_CLASS } from "../lib/constants";
import { isEscPressed } from "../lib/utils";

//TODO - переписать селект
const $SELECTS = $(".js-select");

export const closeDropdown = () => $SELECTS.removeClass(ACTIVE_CLASS);

export function selectFunctions() {
  const setValue = ($target) => {
    const $currentSelect = $target.parents(".js-select");
    const $currentSelectButton = $(".js-select-current-btn", $currentSelect);
    const $currentOptions = $(".js-select-option", $currentSelect);

    const value = $target.data("id");
    const text = $target.text();

    $currentOptions.removeClass(CURRENT_CLASS);

    if ($currentSelectButton.length) {
      $currentSelectButton.text(text);
    }

    $currentOptions.each(function () {
      const $t = $(this);

      if (value === text) {
        $t.addClass(CURRENT_CLASS);
      }
    });

    setNativeValue($currentSelect, value);

    closeDropdown();
  };

  const setNativeValue = ($currentSelect, value) => {
    const $nativeOptions = $("option", $currentSelect);

    $nativeOptions.each(function () {
      const $t = $(this);

      if (Number($t.attr("value")) === value) {
        $nativeOptions.removeAttr("selected");
        $t.attr("selected", "selected");
      }
    });
  };

  const toggleSelectOptions = () => {
    $.each($SELECTS, function (_, el) {
      const $select = $(el);
      const $toggleBtn = $select.find(".js-select-current-btn:first");
      const $optionsBtns = $select.find(".js-select-option");

      const $toggleCalendarBtn = $select.find(
        ".js-search-panel-calendar-input:first"
      );

      $toggleBtn.on("click", function () {
        if ($select.hasClass(ACTIVE_CLASS)) {
          closeDropdown();
        } else {
          $SELECTS.removeClass(ACTIVE_CLASS);
          $select.toggleClass(ACTIVE_CLASS);
        }
      });

      $optionsBtns.on("click", function () {
        const $optionsBtn = $(this);

        if ($optionsBtn.hasClass("js-select-option-open-calendar")) {
          closeDropdown();
          $toggleCalendarBtn.focus();
          $toggleCalendarBtn.trigger("click");
        } else {
          if (!$optionsBtn.hasClass(CURRENT_CLASS)) {
            setValue($optionsBtn);
          } else {
            closeDropdown();
          }
        }
      });
    });
  };

  $DOCUMENT.on("click.select", ({ target }) => {
    if ($(target).closest($SELECTS).length) {
      return false;
    }

    closeDropdown();
  });

  $DOCUMENT.on("keyup.select", (event) => {
    if (isEscPressed(event)) {
      closeDropdown();
    }
  });

  $DOCUMENT.on("change", "select", function () {
    setValue($(this).children(":selected"));
  });

  toggleSelectOptions();
}

export const resetSelect = ($select, nativeText = "Выберите") => {
  const $selectBtns = $select.find(".js-select-option");
  const $currentBtn = $select.find(".js-select-current-btn");
  const $nativeSelect = $select.find("select");
  const $nativeOptions = $select.find("option");

  $currentBtn.text(nativeText);
};
